import api from './client';

export const togglePostLike = async (postId) => {
  const res = await api.post(`/posts/${postId}/like`);
  return res.data;
};

export const togglePostSave = async (postId) => {
  const res = await api.post(`/posts/${postId}/save`);
  return res.data;
};

export const listComments = async (postId) => {
  const res = await api.get(`/posts/${postId}/comments`);
  return res.data;
};

export const addComment = async (postId, text) => {
  const res = await api.post(`/posts/${postId}/comments`, { text });
  return res.data;
};

export const deleteComment = async (postId, commentId) => {
  await api.delete(`/posts/${postId}/comments/${commentId}`);
};

export const toggleFollow = async (username) => {
  const res = await api.post(`/users/${username}/follow`);
  return res.data;
};

export const getFollowers = async (username) => {
  const res = await api.get(`/users/${username}/followers`);
  return res.data;
};

export const getFollowing = async (username) => {
  const res = await api.get(`/users/${username}/following`);
  return res.data;
};

export const getSaved = async () => {
  const res = await api.get('/saved');
  return res.data;
};

export const homeFeed = async (limit = 30) => {
  const res = await api.get('/feed/home', { params: { limit } });
  return res.data;
};

// Phase F1 · Voice-First People Feed
export const peopleFeed = async (params = {}) => {
  const res = await api.get('/feed/people', { params });
  return res.data;
};

export const homeStories = async () => {
  const res = await api.get('/feed/stories');
  return res.data;
};

export const followSuggestions = async (limit = 5) => {
  const res = await api.get('/feed/suggestions', { params: { limit } });
  return res.data;
};

export const uploadLiveCover = async (liveId, file) => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await api.post(`/lives/${liveId}/cover`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};
